<template>
  <div>
    <el-form ref="form" :model="newForm" size="mini">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$l('form_label_custName') || '客户公司全称'">
            <el-input v-model="formData.custName" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_request_type_name') || '申请类型'"
          >
            <el-input v-model="formData.custApprovalRequestTypeName" readonly />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="pt-3 pb-1">
      <div class="d-flex align-items-center justify-content-between mb-2">
        <div class="d-flex align-items-center">
          <h6 class="m-0">
            {{ $l('form_label_bank_number_after_change') || '变更后银行账号' }}
          </h6>
        </div>
      </div>

      <div class="cust-bank-list">
        <el-form
          v-for="(form, index) in newBankList"
          :key="index"
          ref="bankForm"
          :model="form"
          size="mini"
          label-position="top"
          disabled
        >
          <el-row :gutter="10">
            <el-col :span="14">
              <el-form-item
                :label="$l('form_label_bankName') || '开户银行'"
                prop="bankName"
              >
                <span>{{ form.bankName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item
                :label="$l('form_label_bankAccountType') || '账户性质'"
                prop="bankAccountType"
              >
                <span>{{ form.v_bankAccountType }}</span>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="4">
              <el-form-item
                :label="$l('form_label_bankAccountKind') || '账号类别'"
                prop="bankAccountKind"
              >
                <el-input v-model="form.v_bankAccountKind" readonly />
              </el-form-item>
            </el-col> -->

            <el-col :span="14">
              <el-form-item
                :label="$l('form_label_bankAccountName') || '账户名称'"
                prop="bankAccountName"
              >
                <span>{{ form.bankAccountName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item
                :label="$l('form_label_bankAccountNo') || '银行账号'"
                prop="bankAccountNo"
              >
                <span>{{ form.bankAccountNo }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <EmptyContent v-if="!newBankList || !newBankList.length" />
      </div>
    </div>

    <el-form ref="formChange" :model="newForm" size="mini">
      <el-row :gutter="10">
        <el-col :span="24">
          <div class="mt-3 mb-1">
            <h6>
              <span class="text-danger">*</span>
              <span style="color: #101010">
                {{
                  $l('form_label_reason_change_explanation') || '变更原因说明'
                }}
              </span>
            </h6>
          </div>
          <el-form-item prop="remark">
            <div>
              <el-input
                v-model="newForm.remark"
                type="textarea"
                :rows="6"
                :maxlength="500"
                show-word-limit
                clearable
                readonly
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import EmptyContent from '../empty-content'
export default {
  components: { EmptyContent },
  props: {
    formData: { type: Object, default: () => {} },
  },
  data() {
    return {
      newForm: {},
      newBankList: [],
    }
  },
  computed: {},
  watch: {
    formData: {
      handler() {
        if (this.formData && this.formData.updateContent) {
          this.newForm = JSON.parse(this.formData.updateContent)
          this.newBankList = this.newForm.newBankList
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {},
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-input .el-input__inner[readonly='readonly'] {
    background-color: #f9f9f9;
    border: none !important;
  }
}

::v-deep {
  .cust-bank-list {
    .el-form {
      background-color: #f9f9f9;
      padding: 16px;
      padding-bottom: 6px;
      border-radius: 5px;
      margin-bottom: 16px;
    }
    .el-form:last-child {
      margin-bottom: 0;
    }
    .no-data {
      color: #606266;
      font-size: 13px;
    }
  }
}
</style>
